"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TokenProvider;
var jsx_runtime_1 = require("react/jsx-runtime");
var styledGlobalStyle_1 = require("../tokens/styledGlobalStyle");
function TokenProvider(_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styledGlobalStyle_1.GlobalStyle, {}), children] }));
}
